/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

export interface NotificationRowLike {
  type?: string | null;
  title?: string | null;
  message?: string | null;
  data?: Record<string, unknown> | null;
}

export interface NotificationQueryOptions {
  limit?: number;
  unreadOnly?: boolean;
  type?: string | undefined;
  startDate?: string;
  endDate?: string;
}

export function filterNotificationMentions<T extends NotificationRowLike>(
  notifications: T[],
  userId: string,
): T[] {
  return notifications.filter((notification) => {
    if (notification.type?.toLowerCase().includes("mention")) {
      return true;
    }
    if (
      notification.data &&
      typeof notification.data === "object" &&
      "mentions" in notification.data
    ) {
      const mentions = notification.data.mentions;
      return Array.isArray(mentions) ? mentions.includes(userId) : false;
    }
    return false;
  });
}

export function filterNotificationSearch<T extends NotificationRowLike>(
  notifications: T[],
  searchTerm: string,
): T[] {
  const term = searchTerm.toLowerCase();
  return notifications.filter((notification) => {
    const content = `${notification.title ?? ""} ${notification.message ?? ""}`;
    return content.toLowerCase().includes(term);
  });
}

export function buildNotificationSearchParams(
  options: NotificationQueryOptions,
): URLSearchParams {
  const params = new URLSearchParams();
  if (options.limit) params.append("limit", options.limit.toString());
  if (options.unreadOnly) params.append("unread_only", "true");
  if (options.type) params.append("type", options.type);
  if (options.startDate) params.append("start_date", options.startDate);
  if (options.endDate) params.append("end_date", options.endDate);
  return params;
}
